import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualResendPage } from './manual-resend.page';

const routes: Routes = [
  {
    path: '',
    component: ManualResendPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualResendPageRoutingModule {}
